export const notificationsValues = {
  immediately: {
    value: 'immediately',
    label: 'Immediate',
    track: 'Realtime',
  },
  daily: {
    value: 'daily',
    label: 'Una volta al giorno',
    track: 'Daily',
  },
  never: {
    value: 'never',
    label: '',
    track: 'Never',
  },
};

export const APPS_WITH_LS_BOOKMARKS = ['P18', 'P20'];

export const ENPOINTS = {
  save: '/portal-srp/api/v1/mycasa/searches/upsert',
  update: '/portal-srp/api/v1/mycasa/searches/updateBoomark',
  delete: '/portal-srp/api/v1/mycasa/searches/deleteBoomark',
  serialize: '/portal-srp/api/v1/mycasa/searches/serialize',
};

export const apiCallConfig = {
  withCredentials: true,
  headers: {
    accept: 'application/json',
  },
};
